export const ZOE_LOGO_TEMPLATE_ID_PARAMETER_NAME = 'tid';
export const ZOE_DESIGN_TEMPLATE_ID_PARAMETER_NAME = 'dtid';
export const ZOE_LOGO_TEMPLATE_ICON_ID_PARAMETER_NAME = 'iid';
export const ZOE_LOGO_TEMPLATE_ICON_SOURCE_PARAMETER_NAME = 'sid';
export const ZOE_LOGO_TEMPLATE_ICON_URL_PARAMETER_NAME = 'iu';
export const ZOE_LOGO_TEMPLATE_COLOR_PALETTE_ENTITY_ID_PARAMETER_NAME = 'pid';
//# sourceMappingURL=urlParameterNames.js.map